import React from 'react';

const VERIFIED_SOURCE_COPY = {
  'payout-profile': 'Verified via your approved payout profile.',
  'verified-seller': 'Verified through your identity submission.',
  '2257': 'Verified through your approved 2257 compliance documents.',
};

function formatDate(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString();
}

export default function VerificationStatusBanner({ state, verification, submission }) {
  const submittedAt = formatDate(submission?.submittedAt);

  if (state === 'verified') {
    return (
      <div className="verification-status-banner is-verified" role="status">
        <i className="fa-solid fa-circle-check" aria-hidden="true"></i>
        <div>
          <strong>Verified Seller</strong>
          <p>{VERIFIED_SOURCE_COPY[verification?.source] || 'Your seller identity is verified.'}</p>
        </div>
      </div>
    );
  }

  if (state === 'pending') {
    return (
      <div className="verification-status-banner is-pending" role="status">
        <i className="fa-regular fa-clock" aria-hidden="true"></i>
        <div>
          <strong>Submitted, awaiting review</strong>
          <p>
            {submittedAt
              ? `Your identity documents were submitted on ${submittedAt}.`
              : 'Your identity documents are in the review queue.'}
          </p>
        </div>
      </div>
    );
  }

  if (state === 'rejected') {
    return (
      <div className="verification-status-banner is-rejected" role="status">
        <i className="fa-solid fa-circle-exclamation" aria-hidden="true"></i>
        <div>
          <strong>Verification was not approved</strong>
          <p>Review your details and submit new identity images when you are ready.</p>
        </div>
      </div>
    );
  }

  if (state === 'revoked') {
    return (
      <div className="verification-status-banner is-rejected" role="status">
        <i className="fa-solid fa-circle-exclamation" aria-hidden="true"></i>
        <div>
          <strong>Verification was revoked</strong>
          <p>You may submit new identity documents for another review.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="verification-status-banner is-not-started" role="status">
      <i className="fa-solid fa-shield-halved" aria-hidden="true"></i>
      <div>
        <strong>Become a Verified Seller</strong>
        <p>Confirm your identity to help shoppers recognize trusted storefronts.</p>
      </div>
    </div>
  );
}
